<template>
  <div
    :id="'pipeline-record-' + record.id"
    data-loading="false"
    @click="openLeadModal(record.id)"
    :class="['pipeline-record ' + recordIndicator, {'is-deal': record.deal_at}]"
  >
    <div class="handle">
      <p v-if="record.deal_at" class="deal_at_label">Deal on {{ dealAt }}</p>

      <sensitive-data-wrapper>
        <template v-if="record.property.line_1 || record.property.city || record.property.state">
          <h3 class="pipeline-address-text">
            {{ address }}
          </h3>
          <p class="is-size-7 mt-25">
            {{ record.property.city }}<span v-if="record.property.city && record.property.state">,</span>
            {{ record.property.state }} {{ record.property.postcode }}
          </p>
        </template>

        <template v-else>
          <h3 class="pipeline-address-text mb-50">Unknown Address</h3>
        </template>
      </sensitive-data-wrapper>

        <template>
          <p class="is-size-7">
            {{ fullname }}
            <span v-if="contactPhone"><strong>|</strong></span>
            <sensitive-data-wrapper>
              {{ contactPhone | phone }}
            </sensitive-data-wrapper>
          </p>
        </template>

      <div class="mt-50">
        <div v-if="nextAppointment" class="pipeline-dueat-text">
          <span :class="['has-text-weight-bold', { 'due-today-color': appointmentIsToday }]">Next Appointment:</span>
          {{ appointmentDate }}
        </div>
        <div
          v-if="nextTask" class="pipeline-dueat-text">
          <span :class="['has-text-weight-bold', { 'has-text-warning': taskIsToday }, { 'has-text-danger': taskIsOverdue }]">Next Task:</span>
          {{ taskDate }}
        </div>
      </div>

      <div class="mt-50">
        <div class="pipeline-dueat-text">
          <span class="has-text-weight-bold">Entered Status:</span>
          {{ enteredStatusDate }}
        </div>
<!--        <div class="pipeline-dueat-text">-->
<!--          <span class="has-text-weight-bold">Due:</span>-->
<!--          {{ dueAtDate }}-->
<!--        </div>-->
      </div>

      <div class="pipeline-record-footer">
        <div class="left">
          <b-tooltip
            animated
            :label="temperature.label"
            position="is-right"
            v-if="temperature.label != 'None'"
          >
            <icon-default
              class="pipeline-record-footer-icon"
              icon="temperature"
              size="is-small"
              :class="temperature.color"
            ></icon-default>
          </b-tooltip>

          <b-tooltip
            animated
            label="Deal Probability"
            position="is-right"
            v-if="dealProbability.score"
          >
            <icon-default
              class="pipeline-record-footer-icon"
              icon="deal-probability"
              size="is-small"
              :class="dealProbability.color"
            ></icon-default>
          </b-tooltip>

          <b-tooltip
            v-if="record.campaign_id"
            animated
            :label="$store.getters.campaigns.find(c => c.id === record.campaign_id).label"
            position="is-right"
          >
            <icon-default
              class="pipeline-record-footer-icon"
              :icon="$utils.getCampaignIcon(record.campaign_id)"
              size="is-small"
            ></icon-default>
          </b-tooltip>

<!--          <b-tooltip-->
<!--            v-if="incompleteRequiredTasks.length"-->
<!--            animated-->
<!--            :label="`${incompleteRequiredTasks.length} required ${incompleteRequiredTasks.length > 1 ? 'tasks' : 'task'}`"-->
<!--            position="is-right"-->
<!--          >-->
<!--            <icon-default-->
<!--              class="pipeline-record-footer-icon"-->
<!--              icon="task"-->
<!--              size="is-small"-->
<!--              color="is-danger"-->
<!--            ></icon-default>-->
<!--          </b-tooltip>-->

          <b-tooltip
            v-if="missCalls"
            animated
            :label="`${missCalls.count} missed calls`"
            position="is-right"
          >
            <icon-default
              class="pipeline-record-footer-icon"
              icon="call-missed"
              size="is-small"
              color="is-danger"
            ></icon-default>
          </b-tooltip>
        </div>

        <div class="right">
          <app-avatar
            v-for="user in assignedUsers"
            :key="user"
            :user-id="user"
            :size="22"
            class="avatar"
          ></app-avatar>

          <div class="owner-container" v-for="user in record.users" :key="user.id">
            <app-avatar
              :user-id="user.id"
              :size="22"
              class="avatar"
            ></app-avatar>
            <div class="green-dot"></div>
          </div>
        </div>
      </div>
    </div>

    <b-loading
      :id="'pipeline-record-loader-' + record.id"
      class="app-loader"
      style="opacity: 0; pointer-events: none"
      :active="true"
      :is-full-page="false"
    ></b-loading>
  </div>
</template>

<script>
import dates from "../../../../../services/dates";
import SensitiveDataWrapper from "../../../../../components/SensitiveDataWrapper.vue";
import {ENUMS} from "../../../../../services/enums";

export default {
  name: "ActiveRecordItem",
  components: {SensitiveDataWrapper},
  props: {
    record: Object,
    acceptableTime: Number,
  },
  data() {
    return {
      nowDate: dates.getNowISO()
    }
  },
  created() {
    setInterval(() => {
      this.nowDate = dates.getNowISO();
    }, 60000);
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    dealAt() {
      return dates.formatAsDate(this.record.deal_at);
    },
    assignedUsers() {
      return this.$utils.getAssignedUsers(this.record);
    },
    temperature() {
      const label = this.$utils.getEnumLabelDeprecated('temperatureEnum', this.record.temperature);
      const color = label.toLowerCase();

      return { color, label };
    },
    dealProbability() {
      const score = this.record.deal_probability_score;

      let color = 'red';
      if (score > 1 && score <= 3) color = 'yellow';
      if (score >= 4) color = 'green';

      return { color, score };
    },
    // incompleteRequiredTasks() {
    //   return this.$store.getters.pipelineIncompleteTasks.filter(a => a.record_id === this.record.id);
    //   return this.$store.getters.pipelineIncompleteTasks.filter(a => a.record_id === this.record.id && a.is_required_to_change_status);
    // },
    nextTask() {
      if (this.record.nextTask) {
        return dates.getISO(this.record.nextTask.due_at);
      }

      return null;
    },
    taskDate() {
      return dates.formatAsDateTime(this.nextTask);
    },
    taskIsToday() {
      return dates.isBefore(this.nextTask, dates.addDay(this.nowDate))
      // return dates.isToday(this.nextTask);
    },
    taskIsOverdue() {
      return dates.isInPast(this.nextTask);
    },
    nextAppointment() {
      const appointments = this.$store.getters.pipelineAppointments.filter(a => a.record_id === this.record.id)
        .sort((a,b) => new Date(a.start_at) - new Date(b.start_at));

      if (appointments.length) {
        return dates.getISO(appointments[0].start_at);
      }

      return null;
    },
    appointmentDate() {
      return dates.formatAsDateTime(this.nextAppointment);
    },
    appointmentIsToday() {
      return dates.isToday(this.nextAppointment);
    },
    enteredStatusDate() {
      return dates.formatAsDateTime(this.record.active_status.created_at);
    },
    // dueAtDate() {
    //   if (this.nextTask) {
    //     return this.taskDate;
    //   }
    //
    //   return dates.formatAsDateTime(this.record.active_status.due_at);
    // },
    address() {
      return this.record.property.line_1 || 'Unknown Street';
    },
    fullname() {
      const first = (this.record.contact && this.record.contact.first_name) ? this.record.contact.first_name : '';
      const last = (this.record.contact && this.record.contact.last_name) ? this.record.contact.last_name : '';
      const fullname = `${first} ${last}`.trim();

      return (fullname === '') ? 'Unknown Contact' : fullname;
    },
    contactPhone() {
      return (this.record.contact && this.record.contact.phone_1) ? this.record.contact.phone_1 : '';
    },
    recordIndicator() {
      if(dates.isBefore(this.nextTask, this.nowDate)) {
        return 'is-danger';
      } else if (dates.isBefore(this.nextTask, dates.addDay(this.nowDate))) {
        return 'is-warning';
      }

      return '';
    },
    missCalls() {
      return false;
    },
    dueAtToolTip() {
      return dates.formatAsDateTime(this.record.active_status.due_at);
    }
  },
  methods: {
    openLeadModal(id) {
      this.$router.replace({query: {lead: id}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.pipeline-record {
  position: relative;
  display: block;
  margin-bottom: 0.75rem;
  padding: 0.5rem 0.5rem 0.2rem;
  border-left: 5px solid $green;
  cursor: pointer;
  transition: all 0.5s;
  box-shadow: $box-shadow;
  background: $box-color;
  line-height: 15px;

  &:link,
  &:visited {
    color: inherit;
  }

  &.is-warning {
    border-left-color: $yellow;
  }

  &.is-danger {
    border-left-color: $red;
  }

  &.is-deal {
    background-color: #FEF3EF;
  }

  &:hover {
    background: $grey-100;
  }
}

.color-indicator {
  height: 100%;
  width: 5px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: $green;
}

.deal_at_label {
  margin-bottom: 0.5rem;
  font-size: 12px;
  color: $primary;
  font-weight: bold;
}

.pipeline-address-text {
  font-weight: bold;
}

.pipeline-dueat-text {
  width: 100%;
  font-size: 11px;
}

.pipeline-record-notifications {
  margin-top: 0.25rem;

  .icon {
    margin-right: 4px;
  }
}

.pipeline-record-footer {
  @include clearfix();

  .left {
    float: left;
    @include clearfix();
    margin-bottom: 4px;
    margin-top: 4px;
  }

  .right {
    float: right;
    @include clearfix();
    margin-bottom: 4px;
    margin-top: 4px;

    .avatar {
      margin: 0 2px 0;
    }
  }
}

.pipeline-record-footer-icon {
  font-size: 18px;
  float: left;
  margin: 4px 5px 0;

  &.cold {
    color: $blue;
  }

  &.warm {
    color: $yellow;
  }

  &.hot {
    color: $red;
  }

  &.green {
    color: $success;
  }

  &.yellow {
    color: $warning;
  }

  &.red {
    color: $danger;
  }
}

.due-today-color {
  color: #f06d16;
}

.owner-container {
  position: relative;
  display: inline-block;
}

.green-dot {
  position: absolute;
  right: 0;
  bottom: 0;
  background: $success;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
